import { render, staticRenderFns } from "./fancyButton.vue?vue&type=template&id=6267eec4&"
import script from "./fancyButton.vue?vue&type=script&lang=js&"
export * from "./fancyButton.vue?vue&type=script&lang=js&"
import style0 from "./fancyButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports